import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useAtom} from "jotai";
import { FileImageFilled, FilePdfFilled } from '@ant-design/icons';
import { Card, Button, Row, Typography } from "antd";
import { PortalColaboradorService } from "services/PortalColaboradorService";
import { documentoSeleccionadoAtom } from "../../MisDocumentosMovilStorage";
import { saveAs } from "file-saver";

export function SeleccionarTipoCarga({ setSeleccionado, setIsImage, setMostrar }) {
    const { Meta } = Card
    const { Title } = Typography;
    const [urlPlantilla, setUrlPlantilla] = useState("");
    const [documentoSeleccionado,] = useAtom(documentoSeleccionadoAtom);
    
    const gridStyle = {
        width: '50%',
        textAlign: 'center',
        color: "#1c74b3"
    };

    const textStyle = {
        //color: "#1c74b3",
        fontSize: '12px'
    };

    useEffect(() => {
            const cargarUrl = async () => {
                const respuesta =
                    await PortalColaboradorService.obtenerFormatoCarga(
                        documentoSeleccionado?.tipoDocumentoId
                    );
                setUrlPlantilla(respuesta.urlDocumento);
            };
    
            if (documentoSeleccionado != null) cargarUrl();
    }, [documentoSeleccionado, urlPlantilla])
    
    const onClickDescargarPlantilla = () => {
            saveAs(
                urlPlantilla,
                "Formato Carga - " + documentoSeleccionado?.nombreDocumento + ".pdf"
            );
    };
    
    return (
        <>
            <div style={{padding: "10px 50px"}}>
            <Row justify="center">
                {urlPlantilla !== undefined &&
                urlPlantilla !== null &&
                urlPlantilla !== "" && (
                    <Button
                        type="primary"
                        onClick={() =>
                            onClickDescargarPlantilla()
                        }
                    >
                        Descargar Plantilla
                    </Button>
                )}
            </Row>
            </div>
            <div style={{padding: "70px 50px"}}>
                <Row> 
                    <Card
                        hoverable
                        style={gridStyle}
                        cover={<FileImageFilled style={{ fontSize: '50px', marginTop: "20px" }} />}
                        onClick={() => { setSeleccionado(true); setIsImage(true); setMostrar(false) }}
                    >
                        <Meta title={<Title style={textStyle} > Subir Imagen</Title>} />
                    </Card>
                    <Card
                        hoverable
                        style={gridStyle}
                        cover={<FilePdfFilled style={{ fontSize: '50px', marginTop: "20px" }} />}
                        onClick={() => { setSeleccionado(true); setIsImage(true); setIsImage(false); setMostrar(false) }}
                    >
                        <Meta title={<Title style={textStyle} >Subir PDF</Title>} />
                    </Card>
                </Row>
            </div>
        </>
        
    )

}